import request from '@/utils/request'

/**
 * 技师相关API
 */
let TechnicianApi = {
  /**
   * 获取技师列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getList(data, errorback) {
    return request._post('/supplier/technician.technician/index', data, errorback);
  },
  /**
   * 添加技师
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  add(data, errorback) {
    return request._post('/supplier/technician.technician/add', data, errorback);
  },
  /**
   * 修改技师
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  edit(data, errorback) {
    return request._post('/supplier/technician.technician/edit', data, errorback);
  },
  /**
   * 删除技师
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  del(data, errorback) {
    return request._post('/supplier/technician.technician/delete', data, errorback);
  },
  /**
   * 获取技师详情
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  detail(data, errorback) {
    return request._post('/supplier/technician.technician/detail', data, errorback);
  }
}

export default TechnicianApi;


// WEBPACK FOOTER //
// ./src/api/technician/technician.js